define(function(require){
	'use strict';

	var Marionette  	= require('marionette');
	var LPTCollection 	= require('vendor/Backbone/LPTCollection');


	return LPTCollection.extend({

	});
});